import { api } from '..';

// Monitoring metrics endpoints return their payload directly (not wrapped in the
// standard envelope): JSON endpoints resolve to an object, Prometheus to a string.
export const getMetric = async <T = unknown>(path: string): Promise<T> => {
  const { data } = await api.get<T>(path);
  return data;
};
